// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3nkAA","tab":"Tabs_tab__1WBgi","tabActive":"Tabs_tabActive__9YcxB"};